<template lang="pug">

  div
    v-btn(:disabled="loading || error " icon @click="dialog = true")
      v-icon assessment

    v-dialog(v-model="dialog" max-width="100rem")
      v-card
        v-card-text
          v-layout
            v-flex
              v-layout(justify-space-between align-center)
                span(class="body-2 grey--text") Criteria
                v-btn(class="ma-0" icon @click="refresh")
                  v-icon sync
              template(v-for="(criterion, index) in criteria")
                v-layout(:key="'layout-'+criterion.id"
                         align-end
                         style="min-height: 30px;"
                         class="mt-2")
                  v-flex(class="mr-3")
                    span ({{ criterion.weight }}) {{ criterion.statement }}
                  v-flex(shrink)
                    v-checkbox(:input-value="criterion.value === -1"
                               class="ma-0"
                               color="red lighten-3"
                               hide-details
                               @click.native="discard(index)")
                  v-flex(shrink)
                    v-checkbox(:input-value="criterion.value === 1"
                               class="ma-0"
                               color="green lighten-3"
                               hide-details
                               @click.native="keep(index)")
                v-divider(:key="'divider-'+criterion.id")
            v-flex(xs4 offset-xs1)
              v-layout
                v-flex
                  span(class="body-2 grey--text") Result
              v-layout(v-if="completed"
                       align-center
                       class="mt-5"
                       justify-center)
                v-icon(v-if="score >= 0"
                       class="green--text text--lighten-3"
                       size="150") sentiment_satisfied_alt
                v-icon(v-else
                       class="red--text text--lighten-3"
                       size="150") sentiment_very_dissatisfied
              v-layout(v-else
                       align-center
                       class="mt-5"
                       justify-center)
                span(class="display-3") {{ score }}

</template>

<script>
export default {
  name: "worth",
  data () {
    return {
      dialog: false,
      error: false,
      loading: false,
      criteria: [],
      step: 1
    };
  },
  computed: {
    completed () {
      return this.criteria.
        filter((crit) => crit.value !== 0).
        length === this.criteria.length;
    },
    score () {
      let sum = 0;
      for (const crit of this.criteria) {
        sum += crit.value * crit.weight;
      }
      return sum;
    }
  },
  created () {
    this.loading = true;
    this.$http.
      get(`/api/sites/${this.$route.params.id}/decision_matrix`).
      then((r) => {
        for (let i = 0; i < r.data.length; i += 1) {
          this.$set(this.criteria, i, r.data[i]);
        }
      }).
      catch(() => this.error = true).
      finally(() => this.loading = false);
  },
  methods: {
    discard (index) {
      if (this.criteria[index].value === -1) {
        this.criteria[index].value = 0;
      } else {
        this.criteria[index].value = -1;
      }
    },
    keep (index) {
      if (this.criteria[index].value === 1) {
        this.criteria[index].value = 0;
      } else {
        this.criteria[index].value = 1;
      }
    },
    refresh () {
      this.loading = true;
      this.dialog = false;
      this.$http.
        get(
          `/api/sites/${this.$route.params.id}/decision_matrix`,
          { headers: { "Cache-Control": "no-cache" } }
        ).
        then((r) => {
          for (let i = 0; i < r.data.length; i += 1) {
            this.$set(this.criteria, i, r.data[i]);
          }
          this.dialog = true;
        }).
        catch(() => this.error = true).
        finally(() => this.loading = false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Site/Worth.vue